import script from "./CartDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CartDetail.vue?vue&type=script&setup=true&lang=js"

import "./CartDetail.vue?vue&type=style&index=0&id=2a9c4baa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9c4baa"]])

export default __exports__